import { MockFactory } from '@tino-frontend/mocks'
import { PaymentLink, PaymentLinkStatus } from '@types'

export const paymentLinkSentMock = new MockFactory<PaymentLink>({
  id: 'payment-link-id',
  created_at: '2023-07-07T19:24:23.721429Z',
  limit_reservation: {
    created_at: '2023-07-07T19:24:23.721429Z',
    expiration_date: '2023-07-17T19:24:23.721429Z',
  },
  external_id: 'external-id',
  status: PaymentLinkStatus.LinkSent,
  merchant_name: 'FoodFusion Services Ltda',
  amount_cents: 2000,
})
